import { SVGProps } from 'react';
import { cn } from '@/Domain/utils/cn';

export const Spinner = ({ className, ...props }: SVGProps<any>) => (
  <svg
    role="status"
    data-testid="spinner"
    className={cn('h-5 w-5 animate-spin text-foreground', className)}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle
      className="opacity-20"
      cx="12"
      cy="12"
      r="9"
      stroke="currentColor"
      strokeWidth="2.25"
    ></circle>
    <path
      className="opacity-90"
      d="M21 12a9 9 0 0 0-9-9"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
    ></path>
  </svg>
);
